// Score tier helpers shared across the app.
export const SCORE_TIERS = [
  { min: 90, badge: "High Performer", color: "#10B981", text: "text-emerald-500", ring: "#10B981" },
  { min: 75, badge: "Strong Creative", color: "#38BDF8", text: "text-sky-400", ring: "#38BDF8" },
  { min: 60, badge: "Moderate Impact", color: "#F59E0B", text: "text-amber-500", ring: "#F59E0B" },
  { min: 0, badge: "Needs Optimization", color: "#F43F5E", text: "text-rose-500", ring: "#F43F5E" },
];

export function tierFor(score) {
  return SCORE_TIERS.find((t) => score >= t.min) || SCORE_TIERS[SCORE_TIERS.length - 1];
}

export function formatCount(n) {
  if (n == null) return "—";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(n);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

const YT_PATTERNS = [
  /youtube\.com\/watch\?v=([A-Za-z0-9_-]{11})/,
  /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/,
  /youtu\.be\/([A-Za-z0-9_-]{11})/,
  /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,
];

export function extractVideoId(url) {
  if (!url) return null;
  const trimmed = url.trim();
  for (const p of YT_PATTERNS) {
    const m = trimmed.match(p);
    if (m) return m[1];
  }
  if (/^[A-Za-z0-9_-]{11}$/.test(trimmed)) return trimmed;
  return null;
}
